import {
  Avatar,
  Text,
  Box,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Tooltip,
  Spinner,
} from '@chakra-ui/react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import {
  FaHeart,
  FaPen,
  FaRegComment,
  FaRegHeart,
  FaShareAlt,
  FaFlag,
  FaCaretDown,
  FaCaretUp,
} from 'react-icons/fa';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { mutateFunction } from '../../libs/apis';
import CreateCommentModal from '../modal/CreateCommentModal';
import ShareContentModal from '../modal/ShareContentModal';
import { CustomToast } from '../toast/CustomToast';
import MediaDisplay from './MediaDisplay';
import ShareContent from './ShareContent';
import { useSelector } from 'react-redux';
import { WarningTwoIcon } from '@chakra-ui/icons';
import { FaTrash } from 'react-icons/fa';
import { useQueryClient } from 'react-query';
import EditPostModal from '../modal/EditPostModal';
import DeletePostModal from '../modal/DeletePostModal';
import { FaEllipsisV } from 'react-icons/fa';
import userSlice from '../../redux-toolkit/reducers/userSlice';
import ReportPostModal from '../modal/ReportPostModal';
import { BASE_URL } from '../../helpers/constant';
import client from '../../libs/client';
import Comment from './Comment';

const Post = ({ post, refetchPost = () => {}, postId = null }) => {
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const [_post, setPost] = useState(post);
  const { mutate, isLoading } = useMutation(mutateFunction);
  const { addToast } = CustomToast();
  const navigate = useNavigate();
  const {
    isOpen: createCommentModalIsOpen,
    onClose: onCloseCreateCommentModal,
    onOpen: onOpenCreateCommentModal,
  } = useDisclosure();
  const {
    isOpen: createShareContentIsOpen,
    onClose: onCloseShareContent,
    onOpen: onOpenShareContent,
  } = useDisclosure();
  const {
    isOpen: editPostIsOpen,
    onClose: onCloseEditPost,
    onOpen: onOpenEditPost,
  } = useDisclosure();

  const {
    isOpen: deletePostIsOpen,
    onClose: onCloseDeletePost,
    onOpen: onOpenDeletePost,
  } = useDisclosure();

  const {
    isOpen: reportPostIsOpen,
    onClose: onCloseReportPost,
    onOpen: onOpenReportPost,
  } = useDisclosure();

  const [isLiked, setIsLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(0);
  const [commentsCount, setCommentsCount] = useState(0);
  const [message, setMessage] = useState('');
  const [link, setLink] = useState('');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const queryClient = useQueryClient();
  const [isLoadingPost, setIsLoadingPost] = useState(false);
  const [isNestedComment, setIsNestedComment] = useState(false);
  const [isLoadingComments, setIsLoadingComments] = useState(false);
  const [comments, setComments] = useState([]);
  const {
    isOpen: showCommentsIsOpen,
    onClose: onCloseShowComments,
    onOpen: onOpenShowComments,
    onToggle: onToggleShowComments,
  } = useDisclosure({ defaultIsOpen: !!postId });

  const [visibleCount, setVisibleCount] = useState(3);

  const handleShowMore = (e) => {
    e.stopPropagation();
    setVisibleCount((prev) => prev + 10);
  };

  const handleShowLess = (e) => {
    e.stopPropagation();
    setVisibleCount(3);
  };

  const goToPost = (e) => {
    e.stopPropagation();
    navigate(`/post?id=${_post.id}`);
  };

  const likePost = () => {
    try {
      mutate(
        {
          key: 'react/post',
          method: 'post',
          data: {
            post_id: _post.id,
            comment_id: null,
          },
        },
        {
          onSuccess(res) {
            // addToast(res);
            refetchPost();
            // isLiked
            //   ? setLikesCount((prev) => prev - 1)
            //   : setLikesCount((prev) => prev + 1);
            // setIsLiked((prev) => !prev);
          },
          onError(e) {
            // addToast({message: 'Post was not liked'}, "error")
            console.error(e);
          },
        },
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (post) {
      setPost(post);
    }
  }, [post]);

  useEffect(() => {
    setIsLiked(_post.isLiked);
    setLikesCount(_post.likes_count);
    setCommentsCount(_post.comment_count);
    const _message = `Hi! ${_post.user.first_name} ${_post.user.last_name} shared their thoughts on SeedAFounder`;
    const _link = `${process.env.REACT_APP_FRONTEND_URL}public/post?id=${_post.id}`;
    setMessage(_message);
    setLink(_link);
  }, [_post]);

  const onCreateComment = (comment) => {
    setCommentsCount((prev) => prev + 1);
    setComments((prev) => [comment, ...prev]);
  };

  const viewProfileDetails = (e) => {
    e.stopPropagation();
    if (post?.user_id === userInfo?.id) {
      navigate('../account-settings');
    } else {
      const userType = post?.user?.user_type_id;
      const userId = post?.user_id;
      navigate(`../view-user?userid=${userId}&usertype=${userType}`);
    }
  };

  const deletePost = async () => {
    mutate(
      {
        key: `post/${post?.id}`,
        method: 'delete',
      },
      {
        onSuccess(res) {
          addToast(res);
          queryClient.invalidateQueries(`feed?postId=${postId}`);
          onCloseDeletePost();
        },
        onError: (err) => {
          addToast(
            err?.response?.data?.message || 'Error deleting post',
            'error',
          );
        },
      },
    );
  };

  const onEditPost = async (post) => {
    setPost((prev) => ({
      ...prev,
      ...post,
    }));
  };

  const fetchComments = async () => {
    try {
      setIsLoadingComments(true);
      return client()
        .get(
          // commentId
          // ? `${BASE_URL}comment/reply/${commentId}`
          `${BASE_URL}comment/post/${_post.id}`,
        )
        .then((res) => {
          setIsLoadingComments(false);
          const data = res.data.data.comments;
          setComments(data);
          if (!showCommentsIsOpen) {
            onToggleShowComments();
          }
        });
    } catch (error) {
      console.log('The error=====', error);
    }
  };

  const loadComments = async (e) => {
    e.stopPropagation();
    if (comments.length == 0 && !showCommentsIsOpen) {
      fetchComments();
    }
    onToggleShowComments();
  };

  useEffect(() => {
    if (!!postId) {
      fetchComments();
    }
  }, [postId]);

  useEffect(() => {
    fetchComments();
  }, []);

  console.log('comments', comments);
  return (
    <Box className="w-full flex cursor-pointer items-start gap-2 p-2 pt-5">
      <CreateCommentModal
        isOpen={createCommentModalIsOpen}
        onClose={onCloseCreateCommentModal}
        post={post}
        onSuccess={onCreateComment}
        refetchPost={refetchPost}
      />
      <ShareContentModal
        isOpen={createShareContentIsOpen}
        onClose={onCloseShareContent}
        message={message}
        link={link}
        subject={'Hello! Check out this post on SeedAFounder.'}
      />

      <DeletePostModal
        isOpen={deletePostIsOpen}
        onClose={onCloseDeletePost}
        isLoading={isLoading}
        deletePost={deletePost}
      />

      <EditPostModal
        post={post}
        isOpen={editPostIsOpen}
        onClose={onCloseEditPost}
        onSuccess={onEditPost}
      />

      <ReportPostModal
        isOpen={reportPostIsOpen}
        onClose={onCloseReportPost}
        post={post}
      />

      <Box className="w-full cursor-pointer flex px-2 flex-col">
        <Box className="w-full pb-5 min-h-10">
          <Box
            onClick={goToPost}
            className="flex items-start gap-4 justify-between"
          >
            <Box className="flex items-start gap-4">
              <Box className="cursor-pointer">
                <Avatar
                  onClick={viewProfileDetails}
                  src={_post.user.profile_image || null}
                  name={`${_post.user.first_name} ${_post.user.last_name}`}
                  size={'md'}
                />
              </Box>
              <Box className="flex flex-col mb-3">
                <Text
                  as="span"
                  className="font-semibold capitalize"
                  _hover={{
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    color: 'blue.600',
                  }}
                  onClick={viewProfileDetails}
                >
                  {_post.user.first_name} {_post.user.last_name}
                </Text>
                <Text className="text-xs text-gray-500">
                  {moment(_post.createdAt).fromNow()}
                </Text>
              </Box>
            </Box>

            <Box
              className="flex gap-2 items-center justify-center"
              onClick={(e) => e.stopPropagation()}
            >
              {post?.user_id === userInfo?.id && (
                <Menu>
                  <MenuButton
                    as={IconButton}
                    icon={<FaEllipsisV className="text-gray-600 mx-auto" />}
                    variant="unstyled"
                    size="sm"
                    aria-label="Post options"
                    className="hover:bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center transition-all duration-200"
                    _active={{ bg: 'gray-200' }}
                    _hover={{ bg: 'gray-100' }}
                  />
                  <MenuList
                    className="shadow-xl border border-gray-100 rounded-xl py-1"
                    minW="200px"
                  >
                    {moment(post?.createdAt)
                      .add(2, 'hour')
                      .isAfter(moment()) && (
                      <MenuItem
                        icon={<FaPen className="text-gray-600" />}
                        onClick={(e) => {
                          e.stopPropagation();
                          onOpenEditPost();
                        }}
                        className="px-4 py-2.5 hover:bg-gray-50 transition-colors duration-150 font-medium"
                      >
                        Edit post
                      </MenuItem>
                    )}
                    <MenuItem
                      icon={<FaTrash className="text-gray-600" />}
                      onClick={(e) => {
                        e.stopPropagation();
                        onOpenDeletePost();
                      }}
                      className="px-4 py-2.5 hover:bg-gray-50 transition-colors duration-150 text-red-600 font-medium"
                    >
                      Delete post
                    </MenuItem>
                  </MenuList>
                </Menu>
              )}
            </Box>
          </Box>

          <Text className="mt-5 w-full" color="#000">
            {_post?.text.split('\n\n').map((text, index) => {
              // Regular expression to match URLs
              const urlRegex = /(https?:\/\/[^\s]+)/g;
              const parts = text.split(urlRegex);

              return (
                <span key={index}>
                  {parts.map((part, i) => {
                    // Check if the part matches a URL
                    if (part.match(urlRegex)) {
                      return (
                        <a
                          key={i}
                          href={part}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:underline"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {part}
                        </a>
                      );
                    }
                    return part;
                  })}
                  <br />
                </span>
              );
            })}
          </Text>
        </Box>
        {_post.media.length > 0 ? <MediaDisplay media={_post.media} /> : null}
        <Box className="flex items-center justify-between">
          <Box
            onClick={(e) => {
              e.stopPropagation();
              onOpenCreateCommentModal();
            }}
            className="flex gap-1 cursor-pointer pr-2  items-center"
          >
            <FaRegComment className="text-gray-600" />
            <Text>{commentsCount}</Text>
          </Box>
          <Box
            onClick={(e) => {
              e.stopPropagation();
              likePost();
            }}
            className="flex gap-1 pr-2 cursor-pointer items-center"
          >
            {isLiked ? (
              <FaHeart className="text-red-600" />
            ) : (
              <FaRegHeart
                onClick={(e) => {
                  e.stopPropagation();
                  likePost();
                }}
                className="text-gray-600"
              />
            )}

            <Text>{likesCount}</Text>
          </Box>

          <Tooltip
            label="Share post"
            placement="top"
            hasArrow
            bg="gray.700"
            color="white"
            fontSize="sm"
          >
            <Box
              onClick={(e) => {
                e.stopPropagation();
                onOpenShareContent();
              }}
              className="flex gap-1 cursor-pointer items-center"
            >
              <FaShareAlt />
            </Box>
          </Tooltip>

          {post?.user_id !== userInfo?.id && (
            <Tooltip
              label="Report post"
              placement="top"
              hasArrow
              bg="gray.700"
              color="white"
              fontSize="sm"
            >
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  onOpenReportPost();
                }}
                className="flex gap-1 cursor-pointer items-center"
              >
                <FaFlag className="text-gray-600" />
              </Box>
            </Tooltip>
          )}
        </Box>
        {commentsCount > 0 ? (
          <Box className="w-full hidden justify-end">
            <Box
              onClick={loadComments}
              className="flex items-center cursor-pointer hover:font-semibold gap-2"
            >
              <Text className="text-xs">
                {!showCommentsIsOpen ? 'Show' : 'Hide'} Comments
              </Text>
              {!showCommentsIsOpen ? <FaCaretDown /> : <FaCaretUp />}
            </Box>
          </Box>
        ) : null}
        {comments.length > 0 || isLoadingComments ? (
          <>
            <Box className="flex w-full flex-col max-w-2xl mx-auto my-5 gap-1">
              {isLoadingComments ? (
                <Box className="w-full flex justify-center">
                  <Spinner />
                </Box>
              ) : null}
              <>
                {comments.slice(0, visibleCount).map((comment) => {
                  return (
                    <Box className="px-2 bg-white" key={comment.id}>
                      <Comment postLink={comment?.replies_count > 0 ? `/post?id=${_post.id}&commentId=${comment.id}` : `/post?id=${_post.id}`}  parentId={post.id} post={comment} />
                    </Box>
                  );
                })}
                {visibleCount < comments.length && (
                  <Box className="flex w-full justify-end">
                    <Box
                      onClick={handleShowMore}
                      className="flex items-center cursor-pointer hover:font-semibold gap-2"
                    >
                      <Text className="text-xs">Show more</Text>
                      <FaCaretDown />
                    </Box>
                  </Box>
                )}
                {visibleCount >= comments.length && comments.length > 3 && (
                  <Box className="flex w-full justify-end">
                    <Box
                      onClick={handleShowLess}
                      className="flex items-center cursor-pointer hover:font-semibold gap-2"
                    >
                      <Text className="text-xs">Show Less</Text>
                      <FaCaretUp />
                    </Box>
                  </Box>
                )}
              </>
            </Box>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default Post;
